<template>
    <as-modal title="About AccountScore" @close="$emit('close', $event)">
        <p>AccountScore is a third-party service used to provide more financial information for your application. This service uses bank level security processes to connect safely to your bank account. </p>
    </as-modal>
</template>

<script>
    import AsModal from '../Ui/AsModal.vue'
    export default {
        name: "AboutAccountScore",
        components: {
            AsModal,
        }
    }
</script>

